import { render, staticRenderFns } from "./user-list-item-scope-switch.vue?vue&type=template&id=63a0373f&"
import script from "./user-list-item-scope-switch.vue?vue&type=script&lang=js&"
export * from "./user-list-item-scope-switch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports